import React, { useEffect } from 'react';
import { Link, useNavigate } from 'react-router';
import { Button, Box, Typography } from '@mui/material';
import LoginIcon from '@mui/icons-material/Login';
import { useInitiateSignIn } from '@/hooks/useInitiateSignIn';
import { useUser } from '@/providers';
import { useAuth } from '@/providers';

function Landing() {
  const navigate = useNavigate();
  const user = useUser();
  const session = useAuth();
  const initiate_sign_in = useInitiateSignIn();

  useEffect(() => {
    // Only redirect if user is logged in and approved
    if (session?.isLoggedIn && user?.id && user.status === 'approved') {
      navigate('/dashboard');
    }
  }, [session, user, navigate]);

  const renderButton = () => {
    if (session?.isLoggedIn && user?.id) {
      if (user.status === 'approved') {
        return (
          <Button
            component={Link}
            to='/dashboard'
            variant='contained'
            color='brand'
            size='large'
            startIcon={<LoginIcon />}
          >
            Get Started
          </Button>
        );
      } else if (user.status === 'new') {
        return (
          <Button
            component={Link}
            to='/account/signup'
            variant='contained'
            color='brand'
            size='large'
            startIcon={<LoginIcon />}
          >
            Complete Signup
          </Button>
        );
      }
    }

    return (
      <Button
        onClick={initiate_sign_in}
        variant='contained'
        color='brand'
        size='large'
        startIcon={<LoginIcon />}
      >
        Get Started
      </Button>
    );
  };

  if (session?.isLoggedIn && user?.id && user.status === 'approved') {
    return <Box>Redirecting...</Box>;
  }

  return (
    <Box
      sx={{
        textAlign: 'center',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '60vh',
        gap: 2,
      }}
    >
      <Box
        component='img'
        src='/logo.png'
        alt={import.meta.env.VITE_ORG_NAME}
        sx={{
          maxWidth: '400px',
          width: '100%',
          height: 'auto',
        }}
      />
      <Typography variant='h5'>{import.meta.env.VITE_TAG_LINE}</Typography>
      {renderButton()}
    </Box>
  );
}

export default Landing;
